import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { SystemRoutes } from '../../../Utils/RouteUtils';
import { AIAgentScreenContext } from '../AIAgentTypes';

export interface AIAgentScreenSelections {
  powerStationName?: string;
  skidName?: string;
  equipmentName?: string;
  lastUpdatedAt?: string;
}

const EMPTY_SELECTIONS: AIAgentScreenSelections = {};

function resolveLabel(pathname: string, selections: AIAgentScreenSelections): string {
  if (selections.equipmentName) {
    return selections.equipmentName;
  }
  if (selections.skidName) {
    return selections.skidName;
  }
  if (selections.powerStationName) {
    return selections.powerStationName;
  }

  if (pathname.startsWith(SystemRoutes.DASHBOARD)) {
    if (pathname.includes('/power-plant/skid')) {
      return 'Skid';
    }
    if (pathname.includes('/power-plant')) {
      return 'Usina';
    }
    return 'Visão Geral';
  }

  if (pathname.startsWith(SystemRoutes.ANALYSIS)) {
    return 'Análise';
  }

  if (pathname.startsWith(SystemRoutes.COMMUNICATION)) {
    return 'Comunicação';
  }

  if (pathname.startsWith(SystemRoutes.SETTINGS)) {
    return 'Configurações';
  }

  if (pathname.startsWith(SystemRoutes.REPORTS)) {
    return 'Relatórios';
  }

  if (pathname.startsWith(SystemRoutes.AUDIT)) {
    return 'Auditoria';
  }

  if (pathname.startsWith(SystemRoutes.HELP)) {
    return 'Ajuda';
  }

  return 'SGD';
}

export function resolveAIAgentScreenContext(
  pathname: string,
  selections: AIAgentScreenSelections = {}
): AIAgentScreenContext {
  const label = resolveLabel(pathname, selections);
  const context: AIAgentScreenContext = { label };

  if (selections.lastUpdatedAt) {
    context.lastUpdatedAt = selections.lastUpdatedAt;
  }

  return context;
}

export function useAIAgentScreenContext(
  selections: AIAgentScreenSelections = EMPTY_SELECTIONS
): AIAgentScreenContext {
  const location = useLocation();

  return useMemo(
    () => resolveAIAgentScreenContext(location.pathname, selections),
    [location.pathname, selections]
  );
}
